import axios from "axios";

axios.defaults.headers.common["Accept"] = "application/json";

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("auth_token");

    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export default axios;
